/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Level } from './Level';
import {
    LevelFromJSON,
    LevelFromJSONTyped,
    LevelToJSON,
    LevelToJSONTyped,
} from './Level';

/**
 * Full extraction result with hierarchical structure
 * @export
 * @interface ExtractionData
 */
export interface ExtractionData {
    /**
     * 
     * @type {Array<Level>}
     * @memberof ExtractionData
     */
    levels?: Array<Level> | null;
    /**
     * 
     * @type {number}
     * @memberof ExtractionData
     */
    totalRooms?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExtractionData
     */
    totalLineItems?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExtractionData
     */
    grandTotal?: number | null;
}

/**
 * Check if a given object implements the ExtractionData interface.
 */
export function instanceOfExtractionData(value: object): value is ExtractionData {
    return true;
}

export function ExtractionDataFromJSON(json: any): ExtractionData {
    return ExtractionDataFromJSONTyped(json, false);
}

export function ExtractionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExtractionData {
    if (json == null) {
        return json;
    }
    return {
        
        'levels': json['levels'] == null ? undefined : ((json['levels'] as Array<any>).map(LevelFromJSON)),
        'totalRooms': json['totalRooms'] == null ? undefined : json['totalRooms'],
        'totalLineItems': json['totalLineItems'] == null ? undefined : json['totalLineItems'],
        'grandTotal': json['grandTotal'] == null ? undefined : json['grandTotal'],
    };
}

export function ExtractionDataToJSON(json: any): ExtractionData {
    return ExtractionDataToJSONTyped(json, false);
}

export function ExtractionDataToJSONTyped(value?: ExtractionData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'levels': value['levels'] == null ? undefined : ((value['levels'] as Array<any>).map(LevelToJSON)),
        'totalRooms': value['totalRooms'],
        'totalLineItems': value['totalLineItems'],
        'grandTotal': value['grandTotal'],
    };
}

